import './EditMonitorFooter.scss';

import { ConfirmDeleteButton } from '@ui/modals';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { MonitorFormTypes } from '@sonar-software/sonar-core';
import { monitorMenuConfigs } from './MonitorMenu';
import React from 'react';
import { SonarText } from '@ui/text';
import { useBoolean } from '@hooks';

import { Button, Popover, Space } from 'antd';
import { COPY_SPECIFIC, SETTINGS_DATA_SECURITY_COPY } from '@sonar-software/sonar-ts-constants';
import { Else, If, Then } from 'react-if';

export interface EditMonitorFooterProps {
	disableSave?: boolean
	monitor: MonitorFormTypes | undefined
	onCancel: () => void
	onDelete?: () => void
	onSave: (overwrite?:boolean) => void
}

export const EditMonitorFooter: React.FC<EditMonitorFooterProps> = ({
	disableSave,
	monitor,
	onCancel,
	onDelete,
	onSave
}) => {
	const [ showPopover, setShowPopover ] = useBoolean(false);

	const applicationRequired = monitorMenuConfigs.find((config) =>
		config.type === monitor?.monitorConfig?.monitorTypeId)?.applicationRequired;

	return (
		<div className='app-monitor-footer'>
			{ onDelete &&
				<ConfirmDeleteButton
					onConfirm={ onDelete }
					title={ SETTINGS_DATA_SECURITY_COPY.DELETE_MONITOR_CONFIRMATION }
					type='text' /> }
			<Button
				onClick={ onCancel }
				type='default'>
				{ COPY_SPECIFIC.CANCEL }
			</Button>
			<If
				condition={
					!monitor || !monitor?.templateId || (monitor?.templateId && !applicationRequired)
				}>
				<Then>
					<Button
						disabled={ disableSave || !monitor }
						onClick={ () => onSave() }
						type='primary'>
						{ SETTINGS_DATA_SECURITY_COPY.SAVE_MONITOR }
					</Button>
				</Then>
				<Else>
					<Popover
						content={
							<Space direction='vertical'>
								<Space>
									<ExclamationCircleFilled style={ { color: '#FAAD14' } } />
									<SonarText>{
										monitor?.overrideCount === 1 ?
											SETTINGS_DATA_SECURITY_COPY.OVERWRITE_MONITOR_WARNING :
											SETTINGS_DATA_SECURITY_COPY.OVERWRITE_MONITORS_WARNING(
												monitor?.overrideCount ?? 0
											)
									}
									</SonarText>
								</Space>
								<Space>
									<Button
										onClick={ () => setShowPopover.off() }
										type='text'>{ COPY_SPECIFIC.CANCEL }
									</Button>
									<Button onClick={ () => onSave(false) }>
										{ SETTINGS_DATA_SECURITY_COPY.ONLY_CREATE_NEW_MONITORS }
									</Button>
									<Button
										onClick={ () => onSave(true) }
										type='primary'>{ SETTINGS_DATA_SECURITY_COPY.OVERWRITE_MONITORS }
									</Button>
								</Space>
							</Space>
						}
						onOpenChange={ (value) => (value ? setShowPopover.on() : setShowPopover.off()) }
						open={ showPopover && !disableSave }>
						<Button
							disabled={ disableSave }
							type='primary'>
							{ monitor?.applicationIds?.length === 1 ?
								SETTINGS_DATA_SECURITY_COPY.SAVE_ONE_MONITOR :
								SETTINGS_DATA_SECURITY_COPY.SAVE_COUNT_MONITORS(monitor?.applicationIds?.length ?? 0) }
						</Button>
					</Popover>
				</Else>
			</If>
		</div>
	);
};


